import {
    Xtd,
    IModuleMetricDefinition,
    IMetricThreshold
} from "../../dashboard/api/dashboardModels";
import {PageCode} from "../../configuration/api/uiConfigurationModels";
import {ISODateString} from "@/util/dateUtil";

export enum CompareOption {
    None = "None",
    PriorYear5Same = "PriorYear5Same",
    SameDayPriorYear = "SameDayPriorYear",
    Prior5Same = "Prior5Same",
    PriorWeek = "PriorWeek",
    PriorPeriod = "PriorPeriod",
    PriorYear = "PriorYear",
    Prior2Years = "Prior2Years"
}

export interface IMetricDataByDayPartRequest {
    page_PK: number;
    businessUnitIds: string[];
    fromDate: ISODateString | null;
    date: ISODateString;
    xtd: Xtd;
    calendarId: number;
    compareOptions: string[];
    clientConcept_PK: number;
    pageCode: PageCode;
    metricCodes?: string[];
    abortSignal?: AbortSignal;
}

export interface IMetricDataByDayPartResult {
    metricDefinitions: IModuleMetricDefinition[];
    metricDataByDayPart: IBusinessUnitMetricDataByDayPart[];
    dayPartDefinitions: IDayPartDefinition[];
    metricThresholds: IMetricThreshold[];
}

export interface IBusinessUnitMetricDataByDayPart {
    businessUnitPk: number;
    businessUnitId: string;
    businessUnitName: string;
    date: ISODateString;
    xtd: Xtd;
    isLocation: boolean;
    compareOption: string;
    dayPartType: DayPartType;
    metricDayPartData: {
        [dayPartId: string]: {[metricCode: string]: number};
    };
}

export enum DayPartType {
    Unknown = "Unknown",
    Custom = "Custom",
    Hourly = "Hourly"
}

export interface IDayPartDefinition {
    dayPartId: string;
    dayPartAlias: string;
    sortOrder: number;
    dayPartType: DayPartType;
}
